/**
 * FramedPhoto — Reusable photo block with green corner ticks and optional caption strip.
 * Threads consistent imagery treatment across the site.
 */
export default function FramedPhoto({
  src,
  alt = "",
  aspect = "aspect-[4/5]",
  eyebrow,
  label,
  testId,
  className = "",
  objectPosition = "object-center",
}) {
  return (
    <div
      className={`group relative ${aspect} overflow-hidden ${className}`}
      data-testid={testId}
    >
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover ${objectPosition} select-none transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.04]`}
        draggable="false"
      />
      {/* Corner ticks */}
      <span className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-[#F68712]" />
      <span className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-[#F68712]" />
      <span className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-[#F68712]" />
      <span className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-[#F68712]" />

      {(eyebrow || label) && (
        <div className="absolute bottom-0 inset-x-0 bg-[#0A192F]/90 backdrop-blur-sm px-5 py-3 flex items-center justify-between gap-4">
          {eyebrow && (
            <span className="font-mono text-[11px] tracking-widest text-[#F68712] font-bold">
              {eyebrow}
            </span>
          )}
          {label && (
            <span className="text-xs font-bold text-white tracking-wide text-right">
              {label}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
